/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolElectricCarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-electric-car"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.05 15.25L6.05 15.53Q6.05 16.25 5.55 16.75Q5.05 17.25 4.33 17.25Q3.6 17.25 3.1 16.75Q2.6 16.25 2.6 15.53L2.6 8.3Q2.6 8.07 2.64 7.85Q2.67 7.63 2.75 7.42L4.58 2.33Q4.85 1.52 5.53 1.04Q6.2 0.55 7.05 0.55L16.95 0.55Q17.8 0.55 18.48 1.04Q19.15 1.52 19.43 2.33L21.25 7.42Q21.32 7.63 21.36 7.85Q21.4 8.07 21.4 8.3L21.4 15.53Q21.4 16.25 20.9 16.75Q20.4 17.25 19.68 17.25Q18.95 17.25 18.45 16.75Q17.95 16.25 17.95 15.53L17.95 15.25ZM5.75 5.6L18.25 5.6L17.25 2.8Q17.25 2.8 17.25 2.8Q17.25 2.8 17.25 2.8L6.75 2.8Q6.75 2.8 6.75 2.8Q6.75 2.8 6.75 2.8ZM7.45 12Q8.1 12 8.57 11.53Q9.05 11.05 9.05 10.4Q9.05 9.75 8.57 9.28Q8.1 8.8 7.45 8.8Q6.8 8.8 6.33 9.28Q5.85 9.75 5.85 10.4Q5.85 11.05 6.33 11.53Q6.8 12 7.45 12ZM16.55 12Q17.2 12 17.68 11.53Q18.15 11.05 18.15 10.4Q18.15 9.75 17.68 9.28Q17.2 8.8 16.55 8.8Q15.9 8.8 15.43 9.28Q14.95 9.75 14.95 10.4Q14.95 11.05 15.43 11.53Q15.9 12 16.55 12ZM13.05 21.2L13.05 22.23Q13.05 22.6 12.75 22.8Q12.45 23 12.1 22.82L8 20.77Q7.75 20.65 7.81 20.4Q7.88 20.15 8.15 20.15L10.95 20.15L10.95 19.13Q10.95 18.75 11.25 18.55Q11.55 18.35 11.9 18.52L16 20.57Q16.25 20.7 16.19 20.95Q16.13 21.2 15.85 21.2Z" fill={color} />
    </svg>
  );
}
